module.exports = __webpack_public_path__ + "img/map-rays-club.53a67a0a.png";